<!--Main Navigation-->
<header>
  <!--Navbar-->
  <mdb-navbar [containerInside]="false" id="generalnav" SideClass="navbar navbar-expand-lg navbar-light trakly1">
    <mdb-navbar-brand>
      <a class="navbar-brand" href="https://www.trakly.co.za">
        <img src="../../../assets/img/Trakly_Logo_3.png" height="48" alt="Trakly Logo" />
      </a>
    </mdb-navbar-brand>
    <span>{{ appVersionNavigationBar }}</span>
  </mdb-navbar>
  <!--/.Navbar-->
  <div
    *ngIf="environmentBanner"
    class="trakly-env-banner"
    [class.trakly-env-banner--production]="isProductionBanner"
    role="status"
  >
    {{ environmentBanner }}
  </div>
</header>
<!--Main Navigation-->
